import React, { forwardRef, useId } from 'react';
import { useEvent } from '@anton.bobrov/react-hooks';
import { ExpandContent } from '@anton.bobrov/react-components';
import cx from 'classnames';
import { Thumb } from '../Thumb/index.js';
import styles from './index.module.scss.js';

const ThumbCollection = forwardRef(
  ({ className, style, isExpanded, onExpand, name, icon, links }, forwardedRef) => {
    const id = useId();
    const handleClick = useEvent(
      (event) => {
        event.preventDefault();
        onExpand?.(!isExpanded);
      }
    );
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
      Thumb,
      {
        ref: forwardedRef,
        kind: "pure",
        href: "#",
        name,
        icon,
        isExpandable: true,
        isExpanded,
        onClick: handleClick,
        "aria-expanded": isExpanded,
        "aria-controls": id
      }
    ), /* @__PURE__ */ React.createElement(
      ExpandContent,
      {
        isActive: isExpanded,
        duration: 750,
        isContentRendered: false,
        hasAlpha: false
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.list }, links.map((link) => /* @__PURE__ */ React.createElement(Thumb, { ...link, key: link.name, kind: "simple" })))
    ));
  }
);
ThumbCollection.displayName = "ThumbCollection";

export { ThumbCollection };
//# sourceMappingURL=index.js.map
